import { Checkbox } from 'antd'
import { useContext } from 'react'

import {
  ExcelFileUploaderContext,
  ExcelFileUploaderContextType,
} from '../ExcelFileUploader/ExcelFileUploader'
import cn from './ExcelFileSheetsList.module.scss'

function ExcelFileSheetsList() {
  const { allSheets, includedSheets, setIncludedSheets } = useContext(
    ExcelFileUploaderContext
  ) as ExcelFileUploaderContextType

  return (
    <div className={cn.excelFileSheetsList}>
      {allSheets.map((sheet, i) => (
        <div key={`${sheet} ${i}`}>
          <div>
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  setIncludedSheets([...includedSheets, sheet])
                }
                if (!e.target.checked) {
                  setIncludedSheets(
                    includedSheets.filter(
                      (includedSheet) => includedSheet != sheet
                    )
                  )
                }
              }}
              checked={includedSheets.includes(sheet)}
            />
          </div>
          <span>{sheet}</span>
        </div>
      ))}
    </div>
  )
}

export default ExcelFileSheetsList
